<div class="app-container">
  <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
  <form [formGroup]="checkoutForm" (ngSubmit)="isCreating ? createCheckout() : updateCheckout()" *ngIf="checkout">
    <page-header
      [icon]="'fa-money-bill'"
      [title]="isCreating ? 'checkout.new' : 'checkout'"
      [appendNoTranslationTitlePart]="checkout ? checkout.name : ''"
    >
      <ng-container class="header-button">
        <btn
          [label]="'save'"
          [title]="'save' | translate"
          [classes]="['btn-first', 'float-right']"
          [icon]="'far-check'"
          [btnType]="'submit'"
          [isLoading]="loading"
          [spinnerClassesString]="'spinner-white'"
          [btnDisabled]="loading"
          data-cy="create-checkout"
        ></btn>
      </ng-container>
      <btn
        *ngIf="!isCreating && checkout?.deletable"
        [btnType]="'button'"
        [label]="'delete'"
        [title]="'delete' | translate"
        [classes]="['btn-first-red', 'float-right', 'mr-2']"
        [icon]="'far-trash-alt'"
        (onEvent)="deleteCheckout()"
        data-cy="delete-depot"
      ></btn>
      <ng-container class="back-button">
        <btn
          [label]="'back'"
          [title]="'back' | translate"
          [isBackButton]="true"
          [classes]="['btn-third', 'float-right', 'mr-2']"
          [icon]="'far-arrow-left'"
          (onEvent)="triggerBackBtn()"
        ></btn>
      </ng-container>
    </page-header>

    <section class="content">
      <div class="card">
        <div class="row">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-12">
                <form-row-input
                  [label]="'checkout.name'"
                  [formGroup]="checkoutForm"
                  formControlName="name"
                  [required]="checkoutForm.get('name').errors !== null && checkoutForm.get('name').errors.required"
                  [requiredCssClass]="submitted && formControls.name.errors"
                  [noMarginBottom]="true"
                  data-cy="name"
                ></form-row-input>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <form-row-select
                  [label]="'checkout.institution'"
                  [icon]="null"
                  [model]="checkout.institution?.id"
                  (modelChange)="selectInstitution($event)"
                  [options]="institutionsWithNullOption"
                  [dataCyAttribute]="'select-institution'"
                ></form-row-select>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label>{{ 'depots' | translate }}:</label>
                  <div class="mt-2" *ngFor="let depot of depots">
                    <form-row-checkbox
                      [label]="depot.name"
                      [cursorPointer]="true"
                      (change)="toggleDepot(depot, $event)"
                      [model]="isChosenDepot(depot)"
                    >
                    </form-row-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </form>
</div>
